//子级router-view承载
import Center from '@/components/common/center'

//中转发货---库存管理
import Stock from '@/pages/zhongzhuanfahuo/stock/list'

//中转发货---发货管理
import Fahuo from '@/pages/zhongzhuanfahuo/fahuo/list'
import FahuoDetail from '@/pages/zhongzhuanfahuo/fahuo/detail'

export default [{
  path: '/zhongzhuanfahuo',
  component: Center,
  redirect: '/zhongzhuanfahuo/stock',
  meta: {
    title: 'zhongzhuanfahuo'
  },
  children: [{
    path: '/zhongzhuanfahuo/stock',
    component: Stock,
    meta: {
      title: "库存管理"
    },
  },{
    path: '/zhongzhuanfahuo/fahuo',
    component: Center,
    redirect: '/zhongzhuanfahuo/fahuo',
    meta: {
      title: "发货管理"
    },
    children: [{
      path: '/zhongzhuanfahuo/fahuo',
      component: Fahuo,
      meta: {
        title: "发货管理"
      },
    }, {
      path: '/zhongzhuanfahuo/fahuo/detail',
      component: FahuoDetail,
      meta: {
        title: "发货详情"
      },
    }]
  }]
}]



// WEBPACK FOOTER //
// ./src/router/module/zhongzhuanfahuo.js